import { render, staticRenderFns } from "./classificationModal.vue?vue&type=template&id=669730c1&"
import script from "./classificationModal.vue?vue&type=script&lang=js&"
export * from "./classificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports